import { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { handleLogOut } from "../components/eval/components/UserMenu";

/**
 * Custom hook to handle user inactivity logout.
 * @returns {{ resetTimer: () => void, showWarning: boolean,  warningDuration: number }} Object containing a reset function and a warning flag.
 * @param {{ onStateChange?: (state: string, data?: any) => void, timeout: number, warningTime: number }}
 */
function useInactivityLogout({ timeout, warningTime, onStateChange }) {
  const history = useHistory();
  const lastActivityTimeRef = useRef(Date.now());
  const [showWarning, setShowWarning] = useState(false);
  

  const resetTimer = () => {
    lastActivityTimeRef.current = Date.now();
    setShowWarning(false);
  };

  useEffect(() => {
    const handleUserActivity = () => resetTimer();
    const events = ["click", "keypress", "scroll", "touchstart"];

    events.forEach((event) =>
      window.addEventListener(event, handleUserActivity)
    );

    const interval = setInterval(() => {
      const timeSinceLastActivity = Date.now() - lastActivityTimeRef.current;

      if (timeSinceLastActivity > warningTime && timeSinceLastActivity < timeout) {
        setShowWarning(true);
      }

      if (timeSinceLastActivity > timeout) {
        handleLogOut(history, onStateChange);
      }
    }, 1000);

    return () => {
      events.forEach((event) =>
        window.removeEventListener(event, handleUserActivity)
      );
      clearInterval(interval);
    };
  }, [timeout, warningTime, history]);

  return { resetTimer, showWarning, warningDuration: Math.floor((timeout - warningTime) / 1000) };
}

export default useInactivityLogout;
